import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Sport';

const SportApi: any = baseApi(endpoint);

export default SportApi;